<template>
    <v-container fluid class="pa-0">
        <v-row no-gutters class="py-1">
            <v-col class="px-2">
                <slot name="email"></slot>
            </v-col>
            <v-col cols="1" class="px-2">
                <slot name="xocAuth"></slot>
            </v-col>
            <v-col cols="auto" class="pl-2 pt-2">
                <slot name="prefix"></slot>
            </v-col>
            <v-col class="px-2">
                <slot name="username"></slot>
            </v-col>
        </v-row>
        <v-row no-gutters class="py-1">
            <v-col class="px-2">
                <slot name="firstName"></slot>
            </v-col>
            <v-col cols="1" class="px-2"></v-col>
            <v-col class="px-2">
                <slot name="lastName"></slot>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'UserFormLayout'
};
</script>
